import { useState } from "react";
import { FocusedComponentType, FocusedVia } from "./types";
import { useSSOMarketingPopupContext } from "./PopupProvider";
import { Check, Copy } from "react-feather";
import { PostLoginDiscountCardProps } from "./types";

export const PopupCoupon: React.FC<PostLoginDiscountCardProps> = ({
  code,
  title,
  description,
  tagText,
  tagBackgroundColor,
  tagTextColor,
  handleCopyCouponCode,
}) => {
  const {
    popup: {
      postLogin,
      backgroundColor: mainBgColor,
      primaryCTA: { backgroundColor: primaryCTAColor },
    },
    overRides,
  } = useSSOMarketingPopupContext();

  if (!postLogin) return <></>;

  const [isCopied, setIsCopied] = useState(false);

  const copyCouponCode = () => {
    if (code) {
      handleCopyCouponCode?.(code);
      navigator.clipboard.writeText(code);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
  };

  return (
    <div
      onClick={() => {
        overRides?.setFocusedComponent?.({
          type: FocusedComponentType.POST_LOGIN_DISCOUNT_CODE,
          via: FocusedVia.POPUP,
        });
      }}
      className={`ui-flex ui-flex-col ui-p-4 ui-pt-6 ui-rounded-lg ui-shadow-md ui-relative ui-w-full ui-bg-white ${
        overRides?.focusedComponent?.type ===
          FocusedComponentType.POST_LOGIN_DISCOUNT_CODE &&
        "border-2 border-primary-dark"
      }`}
    >
      <div className="ui-absolute ui-top-0 ui-right-3">
        <div
          className="ui-rounded-b-lg ui-text-white ui-border-[1px] ui-border-t-0"
          style={{
            backgroundColor: tagBackgroundColor,
          }}
        >
          <p
            className="ui-text-[8px] ui-py-[4px] ui-px-[8px] "
            style={{ color: tagTextColor }}
          >
            {tagText}
          </p>
        </div>
      </div>
      <p className="ui-font-bold ui-text-lg">{title}</p>
      <p className="ui-text-xs ui-mt-1">{description}</p>

      <div className="ui-flex ui-flex-col ui-gap-1 ui-justify-center ui-items-center">
        <div
          className="ui-text-primary-dark ui-border-dashed ui-border-1 ui-border-primary-dark ui-rounded-lg ui-p-2 ui-mt-4 ui-w-full"
          style={{
            backgroundColor: `${tagBackgroundColor}1A`,
            borderColor: tagBackgroundColor,
          }}
        >
          <p
            className="ui-text-xs ui-w-full ui-text-center"
            style={{ color: tagBackgroundColor }}
          >
            {code}
          </p>
        </div>
        <button
          className="ui-flex ui-flex-row ui-items-center ui-space-x-1 ui-mt-2 ui-text-xxs"
          onClick={copyCouponCode}
        >
          {isCopied ? (
            <>
              <Check size={10} color="#2c874a" />
              <p className="ui-text-yay-dark">COPIED</p>
            </>
          ) : (
            <>
              <Copy size={10} color="#949494" />
              <p className="ui-text-gray-dark">TAP TO COPY CODE</p>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export const PopupDiscountCardSkeleton = () => {
  return (
    <div className="ui-flex ui-flex-col ui-p-4 ui-rounded-lg ui-shadow-md ui-relative ui-w-full ui-bg-white">
      {/* Tag at the top right */}
      <div className="ui-absolute ui-top-0 ui-right-3">
        <div className="ui-rounded-b-lg ui-text-white ui-border-[1px] ui-border-t-0">
          <div className="skeleton-loader ui-text-[8px] ui-py-2 ui-px-2 ui-w-24"></div>
        </div>
      </div>

      {/* Title */}
      <div className="skeleton-loader ui-font-bold ui-text-lg ui-w-3/4 ui-h-6 ui-rounded ui-mt-2"></div>

      {/* Description */}
      <div className="skeleton-loader ui-text-xs ui-mt-1 ui-w-full ui-h-4 ui-rounded"></div>

      <div className="ui-flex ui-flex-col ui-gap-1 ui-justify-center ui-items-center">
        {/* Coupon code box */}
        <div className="ui-border-dashed ui-border-1 ui-rounded-lg ui-p-2 ui-mt-4 ui-w-full">
          <div className="skeleton-loader ui-text-xs ui-w-full ui-h-4 ui-text-center ui-rounded"></div>
        </div>

        {/* Copy button */}
        <div className="ui-flex ui-flex-row ui-items-center ui-space-x-1 ui-mt-2 ui-text-xxs">
          <div className="skeleton-loader ui-h-3 ui-w-3 ui-rounded"></div>
          <div className="skeleton-loader ui-h-3 ui-w-24 ui-rounded"></div>
        </div>
      </div>
    </div>
  );
};
